// @ts-nocheck
/*** SPLIT TEXT ***/

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class SplitText {
    elementId: string;
    wordList: Array<string>;
    splitMarkup: Array<string>;
    refHTMLElement: HTMLElement;

    constructor(elementId: string) {
        this.elementId = elementId;
        this.refHTMLElement = document.querySelector(elementId)
        if (this.refHTMLElement) this.splitText()
    }

    splitText(): void {
        this.refHTMLElement.classList.add('mch-split-text')
        this.wordList = this.refHTMLElement.innerHTML.split(' ')
        this.updatedMarkup()
    }

    updatedMarkup(): void {
        this.splitMarkup = this.wordList.map(word => `<span><span class="inner">${escapeHtml(word.trim())} </span></span>`)
        this.setNewContent()
    }

    setNewContent(): void {
        while (this.refHTMLElement.firstChild) {
            this.refHTMLElement.removeChild(this.refHTMLElement.firstChild);
        }
        const contentString = this.splitMarkup.join("");
        this.refHTMLElement.insertAdjacentHTML("beforeend", contentString);
        this.animateText();
    }

    animateText(): void {
        this.refHTMLElement.classList.remove("hide")
        
        gsap.registerPlugin(ScrollTrigger);

        gsap.to(`${this.elementId} span.inner`, {
            scrollTrigger: {
                trigger: this.elementId,
                toggleActions: "play none none none",
                start: "top 80%",
            },
            duration: .8,
            translateY: 0,
            opacity: 1, 
            stagger: .15, 
            ease: "power.out",
        })
    }

    escapeHtml(unsafe: string) {
        return unsafe
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }
}

